module.exports = __webpack_public_path__ + "media/kazuya.b87dec98.wav";